import './index.css'

/**
 * 标签页下拉组件
 *
 * 这是一个自定义的标签页组件，支持水平排列的标签选择。
 * 每个标签都可以点击，支持选中状态的视觉反馈。
 *
 * @param list - 标签数据源数组，每个项目包含id、label、value等字段
 * @param value - 当前选中的标签值
 * @param tabsDropFun - 标签点击事件处理函数，参数为(item, index)
 * @param props - 其他传递给容器的属性
 *
 * 使用场景：
 * 1. 数据分类切换 - 不同数据类型之间的切换
 * 2. 状态筛选 - 按状态筛选数据列表
 * 3. 视图切换 - 不同视图模式之间的切换
 * 4. 时间范围选择 - 选择不同的时间范围
 * 5. 内容分类 - 内容按分类展示的切换
 * 6. 用户角色切换 - 不同用户角色的切换
 * 7. 功能模块切换 - 不同功能模块的切换
 * 8. 数据源切换 - 不同数据源之间的切换
 *
 * 使用示例：
 * ```tsx
 * // 基础用法
 * const [activeTab, setActiveTab] = useState('all')
 *
 * <TabsDropComponent
 *   list={[
 *     { id: 1, label: '全部', value: 'all' },
 *     { id: 2, label: '进行中', value: 'active' },
 *     { id: 3, label: '已完成', value: 'completed' }
 *   ]}
 *   value={activeTab}
 *   tabsDropFun={(item, index) => {
 *     setActiveTab(item.value)
 *     console.log('选中标签:', item.label)
 *   }}
 * />
 *
 * // 带自定义样式
 * <TabsDropComponent
 *   list={tabList}
 *   value={currentTab}
 *   tabsDropFun={handleTabChange}
 *   className="custom-tabs-style"
 * />
 * ```
 */
export default function TabsDropComponent({ list, value, tabsDropFun, ...props }) {
  return (
    <div className={'flexRow flexRowStart ' + props.className}>
      {list.map(item => {
        return (
          <div
            onClick={e => tabsDropFun(item, item.value)}
            key={item.id}
            className={
              value === item.value
                ? 'head_small_car_cur flexRow head_small_car_all'
                : 'head_small_car flexRow head_small_car_all'
            }
          >
            {item.label}
          </div>
        )
      })}
    </div>
  )
}
